/**
 * Tipos e schemas da área do afiliado (/affiliate/* — requireAuth + registro
 * Affiliate). Valores em "*Cents" são sempre inteiros BRL; o frontend formata.
 * Datas trafegam como ISO 8601 strings.
 */
import { z } from 'zod';
/** Saque mínimo do afiliado: R$ 200,00. */
export const AFFILIATE_MIN_WITHDRAWAL_CENTS = 20_000;
/** Acima de R$ 300,00 a nota fiscal é obrigatória no saque. */
export const AFFILIATE_INVOICE_REQUIRED_ABOVE_CENTS = 30_000;
/**
 * POST /affiliate/withdrawals (multipart — carrega a NF opcional junto).
 * coerce: os campos chegam como string no multipart. Regras (enforcement no
 * service): mínimo R$200; NF obrigatória acima de R$300; saldo suficiente.
 * A solicitação NÃO debita o saldo — o débito acontece na aprovação do admin.
 */
export const requestAffiliateWithdrawalSchema = z.object({
    amountCents: z.coerce.number().int().positive(),
    pixKey: z.string().min(1).max(140),
});
//# sourceMappingURL=affiliate.js.map